export default "__VITE_ASSET__DenyOldA__"